module.exports = __webpack_public_path__ + "689079f03579b8700e9abcf1d6fc50ca.png";